import { STATUS_CONFIG } from "../../constants";
import { MediaItem } from "../../Media.types";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { formatDate } from "../../../../../utils/helper";

interface Props {
  item: MediaItem;
  onView: () => void;
}

const MediaCard: React.FC<Props> = ({ item, onView }) => {
  const { label, icon: Icon, badgeClass } = STATUS_CONFIG[item.status];

  const categoriesByCode = useSelector((state: RootState) =>
    item?.storeInfo?.category
      ? state.reference.categoriesByCode[item.storeInfo.category]?.name
      : undefined,
  );

  const subcategoriesByCode = useSelector((state: RootState) =>
    item?.storeInfo?.subCategory
      ? state.reference.subcategoriesByCode[item.storeInfo.subCategory]?.name
      : undefined,
  );

  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden flex flex-col hover:scale-[1.02] transition-transform hover:shadow-md">
      <div className="relative h-40 cursor-pointer group" onClick={onView}>
        <img
          src={item.thumbnailUrl}
          alt={item?.storeInfo?.storeName}
          className="w-full h-full object-cover"
        />

        <div className="absolute  inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <span className="text-white bg-orange-500 px-4 py-2 rounded-full font-bold">
            Preview Media
          </span>
        </div>

        <MediaTypeIcon type={item.type} />

        <span
          className={`absolute top-3 right-3  text-xs font-semibold ${badgeClass}`}
        >
          {Icon && <Icon fontSize="small" />}
          {label}
        </span>
      </div>

      <div className="p-4 space-y-2 flex-1 flex justify-between ">
        <div>
          <h3 className="font-semibold text-gray-900">
            {item?.storeInfo?.storeName}
          </h3>
          <p className="text-sm text-gray-600">{`${subcategoriesByCode}, ${categoriesByCode}`}</p>
          <p className="text-sm text-gray-500">{`${item?.storeInfo?.address?.city}, ${item?.storeInfo?.address?.state}`}</p>
        </div>

        {/* <div className="flex flex-col gap-2">
          <p className="text-xs text-gray-400">Submitted</p>
          <span>{item?.createdAt}</span>
        </div> */}
      </div>
      <button
        className="w-[90%] mt-3 py-2 rounded-lg border text-gray-700 font-medium hover:bg-gray-50 mx-auto shadow-md"
        onClick={onView}
      >
        View Media
      </button>

      <div className="w-[90%] mx-auto my-3 px-3 flex justify-between font-semibold text-xs text-gray-500 bg-blue-50 py-1 rounded-full">
        <div className="flex flex-col">

        <span>Created on</span>
        <span> {item?.createdAt && formatDate(item?.createdAt)}</span>
        </div>
        <div className="flex flex-col">

        <span>Updated on</span>
        <span>  {item?.updatedAt && formatDate(item?.updatedAt)}</span>
        </div>
      </div>
    </div>
  );
};

export default MediaCard;

const MediaTypeIcon = ({ type }: { type: MediaItem["type"] }) => {
  const Icon =
    type === "VIDEO" ? PlayCircleOutlineIcon : CollectionsOutlinedIcon;

  return (
    <span className="absolute top-3 left-3  text-white bg-black/40 font-semibold text-2xl rounded-full px-1.5">
      <Icon fontSize="small" />
    </span>
  );
};
